import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const SearchIcon = (props) => {
  return (
    <div id = {props.id} onClick = {(e) => props.onClick && props.onClick(e)}>
      <svg className={props.className ? props.className : "svgNew"} viewBox="0 0 64 64" 
      height={props.width ? props.width : "22px"} width={props.width ? props.width : "22px"}>
        <path d="M27,59a1.94,1.94,0,0,1-.87-.2A2,2,0,0,1,25,57V37.77L6.46,17.38A5.61,5.61,0,0,1,10.61,8H53.39a5.61,5.61,0,0,1,4.15,9.38L39,37.77V49a2,2,0,0,1-.75,1.56l-10,8A2,2,0,0,1,27,59ZM10.61,12a1.61,1.61,0,0,0-1.19,2.69l19.06,21A2,2,0,0,1,29,37V52.84L35,48V37a2,2,0,0,1,.52-1.35l19.06-21A1.61,1.61,0,0,0,53.39,12ZM37,49h0Z" />
      </svg>
    </div>
  );
};

export default SearchIcon;
